export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/payment-methods', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/payment-method', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/payment-method/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/payment-method/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/payment-method/' + data.id, { params: data.filters || {} })
  }
})
